import { useCheckFeatureAccessQuery } from '@/services/ApiService';
import { useUser } from '@/hooks/user/useUser';

export const useSkillsFeatureAccess = () => {
    const { user } = useUser();
    const { data } = useCheckFeatureAccessQuery('athena_skills_extraction', {
        skip: !user,
    });

    return {
        hasAccess: data?.hasAccess,
    };
};
